"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradeDuration = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = require("styled-components");
var react_1 = require("react");
var actions_1 = require("../context/actions");
var context_1 = require("../context/context");
var lib_1 = require("../hooks/lib");
var styles_1 = require("../styles");
var base_1 = require("./base");
var Input = function (_a) {
    var _b = _a.placeholder, placeholder = _b === void 0 ? "0" : _b, _c = _a.className, className = _c === void 0 ? "" : _c;
    var duration = (0, lib_1.useDuration)().duration;
    var setCustomDuration = actions_1.stateActions.useSetCustomDuration();
    return ((0, jsx_runtime_1.jsx)(StyledInput, { className: className, value: duration.amount, onChange: function (v) { return setCustomDuration({ resolution: duration.resolution, amount: Number(v) }); }, placeholder: placeholder }));
};
var StyledInput = (0, styled_components_1.styled)(base_1.NumericInput)({
    input: {
        padding: "0px",
    },
});
var Resolution = function (_a) {
    var placeholder = _a.placeholder, _b = _a.className, className = _b === void 0 ? "" : _b;
    var duration = (0, lib_1.useDuration)().duration;
    var setCustomDuration = actions_1.stateActions.useSetCustomDuration();
    var onChange = (0, react_1.useCallback)(function (resolution) {
        setCustomDuration({ resolution: resolution, amount: duration.amount });
    }, [duration.amount, setCustomDuration]);
    return (0, jsx_runtime_1.jsx)(base_1.ResolutionSelect, { className: className, resolution: duration.resolution, onChange: onChange });
};
var TradeDuration = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? "" : _b;
    var shouldWrapOrUnwrapOnly = (0, lib_1.useShouldWrapOrUnwrapOnly)();
    if (shouldWrapOrUnwrapOnly) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(Container, __assign({ className: className }, { children: [children, (0, jsx_runtime_1.jsx)(WarningComponent, {})] })));
};
exports.TradeDuration = TradeDuration;
var usePartialFillWarning = function () {
    var minDurationMillis = (0, lib_1.useMinDuration)().millis;
    var tradeDuration = (0, lib_1.useDuration)().millis;
    var t = (0, context_1.useTwapContext)().translations;
    return (0, react_1.useMemo)(function () {
        if (!tradeDuration)
            return;
        if (minDurationMillis > tradeDuration) {
            return t.partialFillWarning;
        }
    }, [minDurationMillis, tradeDuration, t]);
};
var WarningComponent = function () {
    var durationWarning = (0, lib_1.useTradeDurationWarning)();
    var partialFillWarning = usePartialFillWarning();
    var warning = durationWarning || partialFillWarning;
    if (!warning)
        return null;
    return ((0, jsx_runtime_1.jsx)(base_1.BottomContent, { children: (0, jsx_runtime_1.jsx)(base_1.Message, { title: warning, variant: "warning" }) }));
};
var MaxDurationLabel = function () {
    var translations = (0, context_1.useTwapContext)().translations;
    return ((0, jsx_runtime_1.jsxs)(base_1.Label, { children: [(0, jsx_runtime_1.jsx)(base_1.Label.Text, { text: translations.expiry }), (0, jsx_runtime_1.jsx)(base_1.Label.Info, { text: translations.maxDurationTooltip })] }));
};
var Reset = function (_a) {
    var Component = _a.Component;
    var setCustomDuration = actions_1.stateActions.useSetCustomDuration();
    var customDuration = (0, context_1.useTwapContext)().state.customDuration;
    if (!customDuration)
        return null;
    if (Component) {
        return (0, jsx_runtime_1.jsx)(Component, { onClick: function () { return setCustomDuration(undefined); } });
    }
    return ((0, jsx_runtime_1.jsx)(base_1.Button, __assign({ className: "twap-duration-reset", onClick: function () { return setCustomDuration(undefined); } }, { children: "Default" })));
};
exports.TradeDuration.Resolution = Resolution;
exports.TradeDuration.Input = Input;
exports.TradeDuration.Label = MaxDurationLabel;
exports.TradeDuration.Reset = Reset;
var Container = (0, styled_components_1.styled)(styles_1.StyledColumnFlex)({
    gap: 0,
});
